const infoTextValues = {
  usersTurn: "It's your turn to make a move now",
  computersTurn: "The computer is calculating it's moves",
  userPickedThree: "You were made to pick 3",
  userPickedTwo: "You were made to pick 2",
  userReceivedGeneralMarket: "General market",
  opponentPickedThree: "You played a pick 3 so play again",
  opponentPickedTwo: "You played a pick 2 so play again",
  opponentReceivedGeneralMarket: "You played a general market so play again",
  opponentSuspended: "You played a suspension card so play again",
};

export default infoTextValues;
